class Facebook {
    constructor(faceBookAppId) {
        window.fbAsyncInit = function () {
            FB.init({
                appId: faceBookAppId,
                autoLogAppEvents: true,
                xfbml: true,
                version: 'v12.0'
            });
        };

        (function (s, id) {
            var js,
                fjs = document.getElementsByTagName(s)[0];
            if (document.getElementById(id)) {
                return;
            }
            js = document.createElement(s);
            js.id = id;
            js.src = "//connect.facebook.net/" + app.config.locale + "/sdk.js";
            fjs.parentNode.insertBefore(js, fjs);
        }('script', 'facebook-jssdk'));
    }

    login(type) {
        if (app.auth.accessToken) {
            app.ajax.post("/services/user/auth/facebook", {
                "accesstoken": app.auth.accessToken,
                "type": type,
                "co": app.auth.getThirdPartyCreateOptions()
            }, (response) => {
                if (type === "fill") {
                    app.auth.fillWizard(response);
                } else {
                    if (response.status) {
                        window.location.reload();
                    }
                }
            });
        } else {
            let fbInterval = setInterval(() => {
                if (typeof FB === "object" && FB.hasOwnProperty("login")) {
                    clearInterval(fbInterval);
                    FB.login((response) => {
                        if (response.authResponse) {
                            app.auth.accessToken = response.authResponse.accessToken;
                            app.ajax.post("/services/user/auth/facebook", {
                                "accesstoken": app.auth.accessToken,
                                "type": type,
                                "co": app.auth.getThirdPartyCreateOptions()
                            }, (response) => {
                                if (type === "fill") {
                                    app.auth.fillWizard(response);
                                } else {
                                    if (response.status) {
                                        window.location.reload();
                                    }
                                }
                            });
                        }
                    }, {scope: "email"});
                }
            }, 250);
        }
    }
}